import styled from 'styled-components';
import { Alert } from '@whitelabel/component-library';
import { marginBottom } from '@whitelabel/helpers/style';

const StyledAlertSmall = styled(Alert)`
  ${marginBottom};
`;

export default StyledAlertSmall;
